/* DANNY CARVAJAL PORTFOLIO */

/* MY NAME'S DANNY CARVAJAL AND I HOPE YOU HAVE A GREAT TIME WITH THIS PORTFOLIO. IT'S ALWAYS INTENDED TO BE REALLY INTERACTIVE AND CREATE A COOL EXPERIENCE */

import React from "react";
import ReactDOM from "react-dom";
import App from "./App.jsx";
import "./index.scss";

ReactDOM.render(<App />, document.getElementById("root"));
